module.exports = __webpack_public_path__ + "static/media/_DSC6379_16_9_AR.94c437cc.jpg";